<template>
  <m-pageframe :title="title">
    <v-container class="analytics-container pa-4 pa-md-6" fluid>
      <div class="subcontainer">
        <link-back
          v-if="show_back_link"
          class="mb-4"
          :fallback_route="back_route"
          :fallback_route_text="back_route_text"
        />

        <div v-if="heading || subheading || $slots.header" class="mb-6">
          <slot name="header">
            <h1 v-if="heading" class="text-h4 font-weight-bold mb-2">{{ heading }}</h1>
            <p v-if="subheading" class="text-body-1 text--secondary">{{ subheading }}</p>
          </slot>
        </div>

        <sticky-bar v-if="$slots.filters">
          <slot name="filters" />
        </sticky-bar>

        <div v-if="loading">
          <slot name="loading">
            <section class="metrics-grid mb-8 mt-4">
              <v-skeleton-loader v-for="i in skeleton_count" :key="i" type="card" height="150" />
            </section>
            <v-skeleton-loader type="image" height="450" />
          </slot>
        </div>

        <empty-state
          v-else-if="is_empty"
          :title="empty_title"
          :description="empty_description"
          :icon="empty_icon"
          class="mt-8"
          :shaded="false"
        />

        <div v-else>
          <slot name="content" />
        </div>
      </div>

      <slot name="dialogs" />
    </v-container>
  </m-pageframe>
</template>

<script>
import StickyBar from '@/components/layouts/sticky-bar.vue';

export default {
  name: 'AnalyticsPageLayout',

  components: {
    EmptyState: () => import('@/components/global/empty-state.vue'),
    StickyBar,
  },

  props: {
    title: {
      type: String,
      required: true,
    },

    heading: {
      type: String,
      default: '',
    },

    subheading: {
      type: String,
      default: '',
    },

    loading: {
      type: Boolean,
      default: false,
    },

    is_empty: {
      type: Boolean,
      default: false,
    },

    show_back_link: {
      type: Boolean,
      default: true,
    },

    back_route: {
      type: Object,
      default: null,
    },

    back_route_text: {
      type: String,
      default: '',
    },

    skeleton_count: {
      type: Number,
      default: 6,
    },

    empty_title: {
      type: String,
      default: 'No Data Found',
    },

    empty_description: {
      type: String,
      default: 'Try adjusting your filters to see if we can find some data',
    },

    empty_icon: {
      type: String,
      default: 'mdi-database-search-outline',
    },
  },
};
</script>

<style lang="scss" scoped>
.analytics-container {
  min-height: 100vh;
  background: var(--color-bg-shaded-light);
  margin: 0 auto;
  padding-bottom: 8rem;
}

.subcontainer {
  max-width: 1600px;
  margin: 0 auto;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 24px;
}

@media (max-width: 768px) {
  .metrics-grid {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 16px;
  }
}
</style>
